module.exports = __webpack_public_path__ + "img/merlin prismriver_lw.52e57e70.png";